import { AppUtils } from '../../../../../shared/utils/index';
import { Application } from '../../../../../shared/models/view/Application';
import { AppFormModel } from './AppFormModel';

export class AppApplicationModel extends Application {
	private formModel: AppFormModel;
	constructor(
		register?: string,
		formModel: AppFormModel = new AppFormModel()
	) {
		super(register);

		this.formModel = formModel;
	}

	set FormModel(value: AppFormModel) {
		this.formModel = value;
	}

	get FormModel(): AppFormModel {
		return this.formModel;
	}

	public static createFromObject(dataObject: { [key: string]: any }): AppApplicationModel {
		return AppUtils.Helper.createFromMap(dataObject, AppApplicationModel, (key: string, value: any) => {
			switch (key) { //NOSONAR
				case 'formModel':
					return AppFormModel.createFromObject(value);
				default:
					return value;
			}
		});
	}
}
